// extracted by mini-css-extract-plugin
export default {"container":"ConfirmedEmailPage_container__EtBHL","loading":"ConfirmedEmailPage_loading__eynWN"};